/**
 * `VendorTabs` `tabKey` → `tab` query slug for Active Projects detail (see `staticTabs` `urlTabMapping`).
 * Lowercased when used in URLs so they match `tabQueryToTabKey` lookup.
 */
const ACTIVE_PROJECTS_STATIC_TAB_KEY_TO_URL_SLUG: Record<string, string> = {
  COMPLIANCE_DOCUMENTS: "complianceDocuments",
  MAIN_DETAILS: "mainDetails",
  RECIPE_AND_RAW_MATERIALS: "recipeAndRawMaterials",
  ALLERGENS_AND_SENSITIVITIES: "allergensAndSensitivities",
  NUTRITION: "nutrition",
  PACK_COPY: "packCopy",
  FOOD_AND_SAFETY: "foodSafety",
  STORAGE: "storage",
  PACKAGING: "packaging",
  PACKAGING_AND_LABELLING: "packagingAndLabelling",
  MULTIPACK: "multipack",
  ARTWORK_FILE: "artworkFile",
};

/**
 * Maps the current Active Projects main tab key (e.g. `MAIN_DETAILS`) to the URL `tab` query slug.
 * Does not read `status-config.json`.
 */
export function getActiveProjectsTabQuerySlugFromStaticTabKey(
  activeProjectsStaticTabKey: string | null | undefined
): string | null {
  const tabKey = String(activeProjectsStaticTabKey ?? "").trim();
  if (!tabKey) return null;
  const slug = ACTIVE_PROJECTS_STATIC_TAB_KEY_TO_URL_SLUG[tabKey];
  return slug ? String(slug).toLowerCase() : null;
}
